import { CommonModule } from '@angular/common'
import { Component, output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { ProfilePicComponent } from '../../../../components/profile-pic/profile-pic.component'
import { InternationalizationService } from '../../../../services/internationalization.service'
import { ChatListItem, UserSearchResult } from '../../interfaces/chat.interface'
import { MessageChatStateService } from '../../services/message-chat-state.service'

@Component({
  selector: 'app-chat-sidebar',
  standalone: true,
  imports: [CommonModule, FormsModule, ProfilePicComponent],
  templateUrl: './chat-sidebar.component.html',
  styleUrl: './chat-sidebar.component.scss',
})
export class ChatSidebarComponent {
  readonly chatSelected = output<ChatListItem>()
  readonly userSelected = output<UserSearchResult>()
  readonly searchChanged = output<string>()
  readonly createGroupClicked = output<void>()

  constructor(
    protected state: MessageChatStateService,
    protected translateService: InternationalizationService
  ) {}

  onSearch(value: string): void {
    this.state.searchTerm.set(value)
    this.searchChanged.emit(value)
  }

  selectChat(chat: ChatListItem): void {
    this.chatSelected.emit(chat)
  }

  selectUser(user: UserSearchResult): void {
    this.userSelected.emit(user)
  }

  openCreateGroup(): void {
    this.createGroupClicked.emit()
  }

  truncateMessage(text: string | null | undefined, maxLength = 35): string {
    if (!text) {
      return ''
    }
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
  }
}
